/**
 * @module components/StatusSpinner
 * @description Animated spinner icon component for loading states.
 * Uses ImSpinner11 icon with CSS rotation animation when loading prop is true.
 */

import React from 'react';
import * as Styles from './styles';
import { StatusSpinnerProps } from './types';

/**
 * @component StatusSpinner
 * @summary Conditionally animated spinner icon for loading indicators.
 * Shows static icon when not loading, rotates continuously when loading is true.
 * @type {React.FC<StatusSpinnerProps>}
 * @param {StatusSpinnerProps} props - Component props from types.ts
 * @returns {React.ReactElement} Spinner icon with conditional animation
 */
export const StatusSpinner: React.FC<StatusSpinnerProps> = ({ className, loading = false }) => {
  return <Styles.Icon className={className} $loading={loading} />;
};
